import { makeAutoObservable, observable } from "mobx";
import axios from "axios";

export interface Tournament {
  id: string;
  title: string;
  timestamp: string;
  type: "Gaming" | "Quiz" | any;
}

export type TournamentTab = "Log" | "Details" | "Results" | "Update";

class TournamentStore {
  tournaments: Tournament[] = [];
  focusedTournament: Tournament | null = null;
  openedTab: number = 0;

  constructor() {
    makeAutoObservable(this);
    this.preLoad();
  }

  public preLoad() {
    axios
      .get("https://wallof-backend.uc.r.appspot.com/tournaments", {})
      .then((r) => {
        const officialTournaments = r.data as unknown as any;
        this.tournaments = officialTournaments["official"] as Tournament[];
        console.log(r.data);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  public selectTournament(t: Tournament) {
    this.focusedTournament = t;
  }

  public switchTab(index: number) {
    this.openedTab = index;
  }
}

const tournamentStore = new TournamentStore();

export { tournamentStore };
